module.exports = __webpack_public_path__ + "static/media/rom11.d9a797dd.jpg";